module.exports = __webpack_public_path__ + "img/xs-qrcode-produce.81ac6807.jpg";